import modelBaseV2 from "../model-base-v2.model";

/**
 * Fixture Master Model
 * 
 * This feature is for admin register fixtures.
 * 
 * @author Molly Liu
 */

const campaignModel = {
  getCampaignList: (body) => {
    return modelBaseV2.post('/api/planogram/campaign/search/lists', { body });
  },
  createCampaign: (params) => {
    const body = new FormData();
    for (const p in params) {
      body.append(p, params[p]);
    }
    return modelBaseV2.post('/api/planogram/campaign/save', { body });
  },
  getCampaignById: (campaignId) => {
    campaignId = encodeURIComponent(campaignId);
    return modelBaseV2.get(`/api/planogram/campaign?campaignID=${campaignId}`);
  },
  getCampaignDetails: (params) => {
    return modelBaseV2.get('/api/planogram/campaign/view', { params });
  },
  uploadFixtureSKUMap: (body) => {
    return modelBaseV2.post('/api/planogram/campaign/fixturemap/upload', { body });
  },
  getFixtureSKUMapList: (params) => {
    return modelBaseV2.get('/api/planogram/campaign/fixturemap/list', { params });
  },
  deleteFixtureSKUMaps: (body) => {
    return modelBaseV2.post('/api/planogram/campaign/fixturemap/delete', { body });
  },
  getFixtures: (params) => {
    return modelBaseV2.get('/api/planogram/fixture/name', { params });
  },
  getCampaignStoreList: (params) => {
    return modelBaseV2.get('/api/planogram/view/sitelists', { params });
  },
  downloadRawData: (filename, params) => {
    return modelBaseV2.postDownload(`/api/planogram/campaign/rawdata/download`, { body: params }, filename);
  },
  downloadComplianceReport: (filename, params) => {
    return modelBaseV2.postDownload('/api/planogram/campaign/compliancebysub/download', { body: params }, filename);
  },
  downloadExcelForCompliantElements: (filename, params) => {
    return modelBaseV2.postDownload('/api/planogram/campaign/compliant/download', { body: params }, filename);
  },
  downloadExcelForTargetResponse: (filename, params) => {
    return modelBaseV2.postDownload('/api/planogram/campaign/fixturesku/download', { body: params }, filename);
  },
  downloadCampaignPPT: (filename, params) => {
    return modelBaseV2.postDownload('/api/planogram/campaign/downloadpptx', { body: params }, filename);
  }
}

export default campaignModel;
